import React from 'react';
import { Space } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FiExternalLink } from 'react-icons/fi';
import urlPageTranslationDetails from '../../../../urls/urlPageTranslationDetails';
import IntlMessages from '../../../../layout/components/lang/IntlMessages';
import { PRESETS_SOURCE } from '../../pages/Presets/PagePresets/PagePresets.const';
import { EMPTY_VALUE_PLACEHOLDER } from '../../../../const/system';
import getUrlPathnamePrefix from '../../../../lib/getUrlPathnamePrefix';
import { useGetDictionaryQuery } from '../../../Translations/api/dictionariesApiSlice';



const DictionaryFieldView = ({ dictionaryId = null }) => {
  const { pathname } = useLocation();
  const urlPrefix = getUrlPathnamePrefix(pathname);

  const { data: dictionary = {}, isFetching } = useGetDictionaryQuery({ id: dictionaryId }, { skip: !dictionaryId });

  if (isFetching) {
    return <IntlMessages id="ui-general-loading" />;
  }

  if (!dictionary.id) {
    return <span>{EMPTY_VALUE_PLACEHOLDER}</span>;
  }

  return (
    <Space>
      <Link
        target='_blank'
        to={urlPageTranslationDetails({
          urlPrefix: urlPrefix !== PRESETS_SOURCE ? urlPrefix : null,
          id: dictionaryId,
        })}
      >
        <Space>
          {dictionary?.name ?? EMPTY_VALUE_PLACEHOLDER}
          <FiExternalLink size={14} />
        </Space>
      </Link>
    </Space>
  );
};

DictionaryFieldView.propTypes = {
  dictionaryId: PropTypes.number,
};

export default DictionaryFieldView;
